

import React,{Component} from 'react';

import {Link} from 'react-router-dom';

import axios from 'axios';

class UsersPublicReposViewComponent extends Component{


    constructor (props)
{
    super(props)

    this.state = 
                {
                    username: null,
					data: [],
					userSearchName: null,
					userSearchSelect: null,
					orgSearchSelect: null,
					orgSearchName: null,
					issueSearchSelect: null,
					issueSearchState: null,
					issueSearchName: null,
					loading:true
				}
				
				this.handleUserSubmit = this.handleUserSubmit.bind(this);
				this.userSearchName	= this.userSearchName.bind(this);
				this.userSearchSelect = this.userSearchSelect.bind(this);
				this.handleOrgSubmit = this.handleOrgSubmit.bind(this);
				this.orgSearchSelect = this.orgSearchSelect.bind(this);
				this.orgSearchName = this.orgSearchName.bind(this);
				this.handleIssueSubmit = this.handleIssueSubmit.bind(this);
				this.issueSearchSelect = this.issueSearchSelect.bind(this);
				this.issueSearchState = this.issueSearchState.bind(this);
				this.issueSearchName = this.issueSearchName.bind(this);

}


async componentDidMount(){
    //catch route get parameters
    let urlParam = this.props.match.params.username;

    if((urlParam !== null) && (urlParam !== ""))
    {
        //set username value in state
        this.setState({username: urlParam});
    }
    else
    {
        alert("Bad request!");
        this.props.history.push("/gitsearch/");
    }

   
    //make axios call to API

    try{
       

        let response = await axios({
            method: "get",
            url: `http://mofehintolumumuni.com/gitserver/api/search/preference/github/usersearch/showOne/repos/${urlParam}`
        });

        let status = response.data.status;

        if(status === "success")
        {
			this.setState({data: response.data.data});
			this.setState({loading:false});
        }
        else{
			this.setState({loading:false});
            alert("Bad request");
            this.props.history.push("/gitsearch/");
        }
    
    }
    catch(error)
    {
		this.setState({loading:false});
		alert("An error occurred while loading data from Github server, please refresh your page and try again.");
    }


}


   
userSearchName(e)
{
	this.setState({userSearchName: e.target.value});
}
userSearchSelect(e)
{
	this.setState({userSearchSelect: e.target.value});
	
}
handleUserSubmit(e)
{
	e.preventDefault();

	this.setState({loading:true});

	if((this.state.userSearchName !== null) && (this.state.userSearchName !== "") && (this.state.userSearchSelect !== null) && (this.state.userSearchSelect !== ""))
	{	
		var link = null;
		//check select userSearchSelect type and make axios http if type is user
		if(this.state.userSearchSelect === "user")
		{
			this.showUsers();
		}

		if(this.state.userSearchSelect === "repo")
		{
			
			link = `/gitsearch/search/public/users/repos/${this.state.userSearchName}`;
		}	

		if(this.state.userSearchSelect === "events")
		{
	
		link = `/gitsearch/search/public/users/events/${this.state.userSearchName}`;

		}

		if(this.state.userSearchSelect === "gists")
		{

			link = `/gitsearch/search/public/users/gists/${this.state.userSearchName}`;
		}

		if(link !== null)
		{
			this.setState({loading:false});
			this.props.history.push(link);
		}
	}
	else
	{
		this.setState({loading:false});
		alert("Fill the form properly before submiting!");
	}
}

handleOrgSubmit(e)
{
	e.preventDefault();

	this.setState({loading:true});

	if((this.state.orgSearchSelect !== null) && (this.state.orgSearchSelect !== "") && (this.state.orgSearchName !== null) && (this.state.orgSearchName !== ""))
	{	
		var link = null;
		//check select orgSearchSelect type and make axios http if type is user
	

		if(this.state.orgSearchSelect === "repo")
		{
			link = `/gitsearch/search/public/orgs/repos/${this.state.orgSearchName}`;
		
		}

		if(this.state.orgSearchSelect === "events")
		{
		
			link = `/gitsearch/search/public/orgs/events/${this.state.orgSearchName}`;
		}


		if(link !== null)
		{
			this.setState({loading:false});
			this.props.history.push(link);
		}
	}
	else
	{
		this.setState({loading:false});
		alert("Fill the form properly before submiting!");
	}
}

orgSearchSelect(e)
{
	this.setState({orgSearchSelect: e.target.value});		
}

orgSearchName(e)
{
	this.setState({orgSearchName: e.target.value});
}


issueSearchSelect(e)
{
this.setState({issueSearchSelect: e.target.value});

}

issueSearchState(e)
{
this.setState({issueSearchState: e.target.value});
}

issueSearchName(e)
{
this.setState({issueSearchName: e.target.value});

}


handleIssueSubmit(e)
{
	e.preventDefault();

	this.setState({loading:true});

	if((this.state.issueSearchName !== null) && (this.state.issueSearchName !== "") && (this.state.issueSearchState !== null) && (this.state.issueSearchState !== "") && (this.state.issueSearchSelect !== null) && (this.state.issueSearchSelect !== ""))
	{	
		var link = null;			

		link = `/gitsearch/search/public/issues/view/${this.state.issueSearchName}/${this.state.issueSearchSelect}/${this.state.issueSearchState}`;

		if(link !== null)
		{
			this.setState({loading:false});
			this.props.history.push(link);
		}
		
	}
	else
	{
		this.setState({loading:false});
		alert("Fill the form properly before submiting!");
	}
}






render()
{
    const data = this.state.data;
	var userList = [];
	if(data.length > 0)
	{

    //get object from array
    let outterObject = data[0];

   //get array from object
   let mainObject = Object.values(outterObject)[0];


     userList = mainObject.map(repo =>
        {
            

            let image = repo.owner.avatar_url;
            

            let createdAtDate = repo.created_at.split("T")[0];
           

            let createdAtTime = repo.created_at.split("T")[1].split("Z")[0];
         

            let createdAt = `${createdAtDate} at ${createdAtTime}`;

            


            let updatedAtDate = repo.updated_at.split("T")[0];
           

            let updatedAtTime = repo.updated_at.split("T")[1].split("Z")[0];
         

            let updatedAt = `${updatedAtDate} at ${updatedAtTime}`;



            let pushedAtDate = repo.pushed_at.split("T")[0];
           

            let pushedAtTime = repo.pushed_at.split("T")[1].split("Z")[0];
         

            let pushedAt = `${pushedAtDate} at ${pushedAtTime}`;
           

            return(
            <li key={repo.id}>
          
            <img src={image} title="githubUserImage" alt={repo.owner.login} />
            <section className="list-left">
            <h5 className="title">Repo: {repo.full_name}</h5>
            <h5 className="title">Description: {repo.description}</h5>
            <span className="adprice">Repo Owner: {repo.owner.login}</span>
            <p className="catpath">Repo Clone Link: {repo.clone_url}</p>
            <p className="catpath">Repo Watchers: {repo.watchers}</p>
            <p className="catpath">Language in Repo : {repo.language}</p>
            <p className="catpath">Forks: {repo.forks_count}</p>
            <p className="catpath">Repo Created on: {createdAt}</p>
            <p className="catpath">Repo Updated on: {updatedAt}</p>
            <p className="catpath">Repo Pushed on: {pushedAt}</p>
            

            </section>
            <section className="list-right">
            <span className="date"><a href={repo.html_url}>View Repo on Github</a></span>
            <span className="date"><a href={repo.owner.html_url}>View Repo Owner on Github</a></span>
            <span className="date"><a href={repo.homepage}>View repo web platform</a></span>
            
          
            </section>
            <div className="clearfix"></div>
            </li> 
            )

        });
		
	}
return(
       	<React.Fragment>
        <div className="banner text-center">
			<div className="container">    
				  <h1>Welcome to gitSearch <span className="segment-heading"> This application allows you to store </span> Github usernames, organization usernames, and issues.</h1>
				  <p>You would get search results for repository information, events, gists etc... directly from Github once you store Github usernames, organization usernames, and issues</p>
				  <div className="personal-details">
						<Link to="/gitsearch/login">SAVE GITHUB DATA </Link> 
				<br></br>
                <br></br>
						</div>
			</div>
	</div>

	<div className="total-ads main-grid-border">
		<div className="container">
		<div class="select-box">
				
				<div class="clearfix"></div>
			</div>
			
			<div className="ads-grid">
				
			<div className="side-bar col-md-3">
					
			<form onSubmit={this.handleUserSubmit}>
                    <h3 className="sear-head"><strong>Search Github Users</strong></h3>
					<div className="brand-select">
						<h4 className="sear-head">Select preference</h4>
						  <select className="selectpicker" data-live-search="true" onChange={this.userSearchSelect}>
						  <option value="">Select option</option>
						  
						  <option value="events">User Events</option>
						
						  <option value="gists">User Gists</option>
						</select>
					</div>
					
					<div className="search-hotel">
					<h4 className="sear-head">User name</h4>
					
						<input type="text" placeholder="Enter name..." onChange={this.userSearchName} />
						<input  type="submit" value="GO" /> 
				
                   
					</div>
                     </form>
					 <br></br>
					 <br></br>
					
					
					
					<form onSubmit={this.handleOrgSubmit}>
                    <h3 className="sear-head"><strong>Search Organization name</strong></h3>
					<div className="brand-select">
						<h4 className="sear-head">Select preference</h4>
						  <select className="selectpicker" data-live-search="true" onChange={this.orgSearchSelect}>
						  <option value="">Select option</option>
						  <option value="repo">Repo Search</option>
						  <option value="events">Events Search</option>
						 				
						</select>
					</div>
					
					<div className="search-hotel">
					<h4 className="sear-head">Organization name</h4>
					
						<input type="text" placeholder="Enter Organization name..." onChange={this.orgSearchName} />
						<input  type="submit" value="GO" /> 
				
                   
					</div>
                     </form>
					 <br></br>
					 <br></br>
					
				<form onSubmit={this.handleIssueSubmit}>
                <h3 className="sear-head"><strong>Search Github Issue</strong></h3>
					<div className="brand-select">
						<h4 className="sear-head">Select Programming Language</h4>
						  <select className="selectpicker" data-live-search="true"  onChange={this.issueSearchSelect}>
						  <option value="">CHOOSE LANGUAGE</option>
						  <option value="php">PHP</option>
						  <option values="javascript">JAVASCRIPT</option>
						  <option value="c-sharp">C-SHARP</option>
						  <option value="python">PYTHON</option>
						  <option value="dart">DART</option>
						  <option value="delphi">Delphi</option>
						  <option value="elixir">ELIXIR</option>
						  <option value="erlang">ERLANG</option>
						  <option value="hack">HACK</option>
						  <option value="kotlin">KOTLIN</option>
						  <option value="lua">LUA</option>
						  <option value="rust">RUST</option>
						  <option value="typescript">TYPESCRIPT</option>
						  <option value="unrealscript">UNREALSCRIPT</option>
						  <option value="C">C</option>
						  <option value="C++">C++</option>
						  <option value="GO">GO</option>
						  <option value="ruby">RUBY</option>
						  <option value="java">JAVA</option>
						  <option value="solidity">SOLIDITY</option>
						  <option value="swift">SWIFT</option>
						  <option value="r">R</option>
						  <option value="objective-c">OBJECTIVE-C</option>
						  <option value="sql">SQL</option>
						  <option value="haskel">HASKEL</option>
						  <option value="powershell">POWERSHELL</option>
						  <option value="fortran">FORTRAN</option>
						 
						</select>
					</div>
                    
                    <div className="brand-select">
						<h4 className="sear-head">Select issue state</h4>
						  <select className="selectpicker" data-live-search="true" onChange={this.issueSearchState}>
						  <option value="">Select option</option>
						  <option value="open">OPEN</option>
						  <option value="closed">CLOSED</option>
						 
				
						</select>
					</div>
				
					<div className="search-hotel">
					<h4 className="sear-head">Enter Issue</h4>
					
						<input type="text" placeholder="Enter Issue..." onChange={this.issueSearchName} />
						<input  type="submit" value="GO" /> 
					
					</div>
					</form>
					</div>

				<div className="ads-display col-md-9">
				{(this.state.loading) ? <h3>Loading data from Server <i className="fa fa-cogs" ></i> </h3> : null}
					<div className="wrapper">					
					<div className="bs-example bs-example-tabs" role="tabpanel" data-example-id="togglable-tabs">
					  <ul id="myTab" className="nav nav-tabs nav-tabs-responsive" role="tablist">
						<li role="presentation" className="active">
						  <a href="#home" id="home-tab" role="tab" data-toggle="tab" aria-controls="home" aria-expanded="true">
							<span className="text">Search Result</span>
						  </a>
						</li>
						
					  </ul>
					  <div id="myTabContent" className="tab-content">
						<div role="tabpanel" className="tab-pane fade in active" id="home" aria-labelledby="home-tab">
						   <div>
								<div id="container">
							
								<div className="clearfix"></div>
							<ul className="list">
							
                            {userList}


							</ul>
						</div>
							</div>
						</div>
						
					  </div>
					</div>
				</div>
				</div>
				<div className="clearfix"></div>
			</div>
		</div>	
	</div>
</React.Fragment>

           
);

}



}




export default UsersPublicReposViewComponent;
